import React from "react";
import { Icon } from "semantic-ui-react";

function ZoomSlider({ scaleValue, scaleChange, minScaleValue }) {
  const onSlide = (e) => {
     scaleChange(Number(e.target.value))
  };
  return (
    <div className="zoom-slider-container">
      <div
        className="zoom-slider-btn"
        onClick={() => scaleChange((scaleValue || 0.18999) + 0.15)}
      >
        <Icon name="plus" />
      </div>
      <div className="slider-container">
        <input
          className="slider"
          type={"range"}
          orient={"vertical"}
          value={Number(scaleValue)}
          min={1}
          max={6}
          onChange={onSlide}
          step={0.15}
        />
        <span onClick={() => scaleChange(minScaleValue)}>
          <Icon name="refresh" />
        </span>
      </div>
      <div
        className="zoom-slider-btn"
        onClick={() => scaleChange(scaleValue - 0.15)}
      >
        <Icon name="minus" />
      </div>
    </div>
  );
}

export default React.memo(ZoomSlider);
